import { NameValueType } from '@/types';

export const ESTIMATE_TYPE_CODE_STYLE = 'STYLE';
export const ESTIMATE_TYPE_CODE_BASIC = 'BASIC';
export const ESTIMATE_TYPES: NameValueType<string>[] = [
  {
    name: '스타일 공사',
    value: ESTIMATE_TYPE_CODE_STYLE,
  },
  {
    name: '기본 공사',
    value: ESTIMATE_TYPE_CODE_BASIC,
  },
];
